import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome'
import moment from 'moment';
import numeral from 'numeral';
import Pagination from 'react-js-pagination';
import Box from '../Layout/Box';
import ButtonStrip from '../Layout/ButtonStrip';
import BoxButton from '../Layout/BoxButton';
import history from '../../utils/history';
import ModalSelectorFromList from '../Shared/ModalSelectorFromList';
import ModalFilter from './ModalFilter';
import SelectorInput from '../Shared/SelectorInput';
import store from '../../utils/store';
import { changeNumberRegisterToShow, downloadFile, getGestionResponsableCompras, setOrderBy, showHideModalFilter, updateInputs } from '../../actions/reportes';
import { showModalSelector, selectFromSelector } from '../../actions/common';
import { extractKeyValue } from '../../utils/helpers';

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
    let value = x.getIn(c.value.split('.'))
    if (c.value === 'estado') {
        value = enums.solicitudes.estados[value]
    } else if (c.value === 'tipo') {
        value = enums.solicitudes.tipos[value].caption
    }
    return value
}

class GestionResponsableCompras extends React.Component {


    handleOpenSelectorResponsableCompras = (list) => {

        let columns = [
            { id: 1, caption: 'Username', value: 'USUARIO', width: '30%' },
            { id: 2, caption: 'Nombres', value: 'NOMBRES', width: '45%' },
            { id: 3, caption: 'Almacén', value: 'ALMACEN', width: '25%' }
        ];

        const payload = {};

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', payload);
        };

        this.props.showModalSelector('Listado de proveedores', columns, `/solicitudes/bienes-investigacion/responsables-almacen`, fn);
    }


    newPageOfResults(pg) {
        this.props.search(pg);
    }

    downloadFile(type_report) {
        const url = '/reportes/download_gestion_responsable_compras';
        const params = {
            fecha_inicio: this.props.reportes.getIn(['manage_purchasing_manager', 'initial_date']),
            fecha_fin: this.props.reportes.getIn(['manage_purchasing_manager', 'final_date']),
            tipo_solicitud: this.props.reportes.get('request_type'),
            filters: this.props.reportes.getIn(['manage_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS(),
            type_report
        };
        return this.props.downloadFile(url, params, type_report);
    }

    render() {

        const { reportes, enums, orderBy, showRecords, totalRecords, page } = this.props;

        const tableCols = [
            { id: 1, caption: 'Responsable compras', value: 'responsable', type: 'string', format: '', width: '25%' },
            { id: 2, caption: 'Tipo solicitud', value: 'tipo', type: 'string', format: '', width: '8%', enums: extractKeyValue(enums.solicitudes.tipos, 'caption') },
            { id: 3, caption: 'Total Solicitudes', value: 'total_solicitudes', type: 'number', format: '0,0', width: '8%' },
            { id: 4, caption: 'Gestionadas', value: 'gestionados', type: 'number', format: '0,0', width: '10%' },
            { id: 5, caption: 'Sin gestionar', value: 'no_gestionados', type: 'number', format: '0,0', width: '10%' },
            { id: 6, caption: 'Total Documentos', value: 'total_documentos', type: 'number', format: '0,0', width: '20%' },
            { id: 7, caption: 'Ordenes', value: 'ordenes', type: 'number', format: '0,0', width: '20%' },
            { id: 8, caption: 'Contratos', value: 'contratos', type: 'number', format: '0,0', width: '20%' },
            { id: 9, caption: 'Compras directas', value: 'facturas', type: 'number', format: '0,0', width: '40%' },
        ];
        
        const boxActions = [
            <BoxButton key="ba[0][0]" name="search" title="Buscar" onClick={e => this.newPageOfResults(1)} />,
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>,
            <BoxButton key="ba[0][2]" name="file-excel-o" onClick={ e => this.downloadFile('xlsx') } title="Descargar excel"/>,
            <BoxButton key="ba[0][3]" name="file-pdf-o" onClick={ e => this.downloadFile('pdf') } title="Descargar PDF"/>,
        ];
        const pagination = <Pagination
            activePage={page}
            itemsCountPerPage={showRecords}
            totalItemsCount={ totalRecords }
            pageRangeDisplayed={10}
            onChange={(pg) => this.newPageOfResults(pg)}
            firstPageText={<FontAwesome name="angle-double-left" />}
            prevPageText={<FontAwesome name="angle-left" />}
            nextPageText={<FontAwesome name="angle-right" />}
            lastPageText={<FontAwesome name="angle-double-right" />}
        />



        const formRequest = <div className="row" style={{padding:'0px'}}>
            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="initial_date" className="control-label">Fecha Inicial</label>
                    <input type="date" className="form-control input-sm" name="initial_date"
                        value={reportes.getIn(['manage_purchasing_manager', 'initial_date'])}
                        onChange={(e) => this.props.updateInputs("manage_purchasing_manager.initial_date", e.target.value)} />
                </div>
            </div>
            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="final_date" className="control-label">Fecha Final</label>
                    <input type="date" className="form-control input-sm" name="final_date"
                        value={reportes.getIn(['manage_purchasing_manager', 'final_date'])}
                        onChange={(e) => this.props.updateInputs("manage_purchasing_manager.final_date", e.target.value)} />
                </div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
                <div className="form-group">
                    <div className="row" style={{ marginTop: '15px'}}>
                        <div className="col-md-4">
                            <input 
                            type="checkbox" 
                            id="request_type"
                            name="request_type" 
                            checked={reportes.get('request_type')}
                            onChange={(e) => this.props.updateInputs('request_type', e.target.checked)}
                            style={{width: '20px', height:'20px', marginRight: '5px'}}
                            />
                            <label htmlFor="request_type" className="control-label">
                                <span style={{float: 'left', marginTop: '10px'}}>Tipo solicitud</span>                                                        
                            </label> 
                        </div>                                            
                    </div>
                </div>
            </div>
        </div>



        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>


                    <Box title="Reporte de Gestión de Responsable de Compras" stretch>


                        <ButtonStrip actions={boxActions} totalRecords={totalRecords}
                            showRecords={showRecords} pagination={pagination}
                            changeRecordsToShow={(records) => this.props.changeNumberRecordsToShow(records)}
                            formRequest = { formRequest }  
                        />


                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>
                            <div style={{ display: 'flex', height: '100%', justifyContent: 'space-between', flexDirection: 'column' }}>   

                                <table className="table table-condensed table-bordered table-striped table-sorted nowrap text-center" id="table-evaluacion-proveedor">
                                    <thead>
                                        <tr>
                                            <th width="30%" colSpan="2"></th>
                                            <th width="30%" colSpan="3" className="text-center">Solicitudes</th>
                                            <th width="40%" colSpan="4" className="text-center">Documentos</th>
                                        </tr>
                                        <tr>
                                            {
                                                tableCols.map(x => {
                                                    const style = { width: `${x.width}` }
                                                    return (
                                                        <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) }
                                                            className={`text-center ${(orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : ''}`} title={ x.caption }>
                                                            { x.caption }
                                                        </th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            reportes.getIn(['manage_purchasing_manager', 'data']).size > 0 ? reportes.getIn(['manage_purchasing_manager', 'data']).map((x, index) => {
                                                return (
                                                    <tr key={`tr1[${x.get('proveedor_id')}${index}]`} className={x.get('selected') ? 'info' : ''}>
                                                        {
                                                            tableCols.map(c => {
                                                                let alignment = 'left'
                                                                let value = findValues(c, x)
                                                                if (reportes.getIn(['manage_purchasing_manager', 'show_request_type']) && c.value === 'tipo') {
                                                                    value = ""
                                                                }
                                                                if (c.type) {
                                                                    switch (c.type) {
                                                                        case 'datetime':
                                                                            value = value ? moment(value).format(c.format) : '';
                                                                            alignment = 'right';
                                                                            break
                                                                        case 'bool':
                                                                            if (typeof value === 'string') value = parseInt(value, 10)
                                                                            value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                            break
                                                                        case 'number':
                                                                            value = numeral(value).format(c.format)
                                                                            alignment = 'right'
                                                                            break
                                                                        default:
                                                                    }
                                                                }
                                                                const style = { textAlign: alignment }

                                                                if (c.LinkToEdit) {
                                                                    return (
                                                                        <td key={`td1[${x.get('id')}][${c.id}]`} className='LinkToEdit' style={style} onClick={e => history.push(window.FOLDER + `/solicitudes/${enums.solicitudes.tipos[x.get('tipo')].url}/${x.get('id')}`)}>{value}</td>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <td key={`td1[${x.get('id')}][${c.id}]`} style={style}>{value}</td>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={tableCols.length}>No existen registros</td></tr>
                                        }
                                    </tbody>
                                    <tfoot>
                                        {
                                            reportes.getIn(['manage_purchasing_manager', 'accumulate']).size > 0 && reportes.getIn(['manage_purchasing_manager', 'accumulate']).map((x, index) =>
                                                <tr key={`acc[${index}]`}>
                                                    <td style={{textAlign: 'right'}} colSpan="2"><strong>Totales:</strong></td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_solicitudes', 0)).format('0,0')}</td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_gestionados', 0)).format('0,0')}</td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_no_gestionados', 0)).format('0,0')}</td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_documentos', 0)).format('0,0')}</td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_ordenes', 0)).format('0,0')}</td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_contratos', 0)).format('0,0')}</td>
                                                    <td style={{textAlign: 'right'}}>{numeral(x.get('total_facturas', 0)).format('0,0')}</td>
                                                </tr>
                                            )
                                        }
                                    </tfoot>
                                </table>

                            </div>
                        </div>


                    </Box>
                </div>
                <ModalSelectorFromList />
                <ModalFilter />
            </div>
        );
    }
}




const mapStateToProps = (state) => {
    const { reportes } = state;
    return {
        reportes,
        orderBy: reportes.getIn(['manage_purchasing_manager', 'orderBy']),
        enums: state.common.get('enums').toJS(),
        showRecords: reportes.getIn(['manage_purchasing_manager', 'showRecords']),
        totalRecords: reportes.getIn(['manage_purchasing_manager', 'totalRecords']),
        page: reportes.getIn(['manage_purchasing_manager', 'page']),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        //getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols, 'manage_purchasing_manager')),
        setOrderBy: (field) => dispatch(setOrderBy(field, 'manage_purchasing_manager')),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        changeNumberRecordsToShow: (number) => dispatch(changeNumberRegisterToShow(number, 'manage_purchasing_manager')),
        search: (page = 1) => dispatch(getGestionResponsableCompras(page)),
        downloadFile: (url, params, type) => dispatch(downloadFile(url, params, `GestionResponsableCompras.${type}`)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GestionResponsableCompras);


// WEBPACK FOOTER //
// ./src/components/Reportes/GestionResponsableCompras.jsx